export type HouseBillingHistoryItem = {
    amount: number;
    /**
     * Formatted in `YYYY-MM-DD`.
     */
    billingDate: string;
    catalogId: number | null;
    /**
     * Formatted in `YYYY-MM-DD`.
     *
     * Older rows can possibly be `null`.
     */
    dateCreated: string | null;
    description: string;
    id: number;
    invoiceId: number | null;
    /**
     * User's **full name** (*not* their username).
     */
    postedBy: string | 'System' | 'Unattributed';
};

export type HouseBillingHistorySlice = {
    byId: {
        [houseId: number]: HouseBillingHistoryItem[];
    };
    loading: number[];
};

export const defaultHouseBillingHistorySlice: HouseBillingHistorySlice = {
    byId: {},
    loading: [],
};
